import { createRouter, createWebHistory } from 'vue-router'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/index.vue'

// declare module 'vue-router' {
//   interface _RouteRecordBase {
//     hidden?: boolean | string | number
//   }
// }

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home'
  },
  /* 登陆页面 */
  {
    path: '/login',
    name: 'login',
    meta: {
      hidden: true
    },
    component: () => import('@/views/login/index.vue')
  },
  /* layout 页面 */
  {
    path: '/home',
    name: 'Home',
    component: Layout,
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/home/index.vue'),
        meta: {
          title: 'home',
          icon: 'icon-Home'
        }
      }
    ]
  },
  {
    path: '/order',
    name: 'Order',
    component: Layout,
    redirect: '/order/index',
    meta: {
      title: 'order',
      icon: 'icon-Order'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/order/index.vue'),
        meta: {
          title: 'order',
          icon: 'icon-order-u'
        }
      },
      {
        path: '/order/abandoned',
        name: 'AbandonedOrder',
        component: () => import('@/views/order/abandoned/index.vue'),
        meta: {
          title: 'abandonedorder',
          icon: 'icon-orders'
        }
      }
    ]
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Layout,
    redirect: '/settings/storebindsettings',
    meta: {
      title: 'settings',
      icon: 'icon-settings'
    },
    children: [
      {
        path: '/settings/storebindsettings',
        name: 'StoreBindSettings',
        component: () => import('@/views/settings/storeBindSettings/index.vue'),
        meta: {
          title: 'storeBindingSettings',
          icon: 'icon-store-setting'
        }
      },
      {
        path: '/settings/paymentdoamin',
        name: 'Paymentdoamin',
        component: () => import('@/views/settings/paymentDomain/index.vue'),
        meta: {
          title: 'paymentdoamin',
          hidden: true
        }
      },
      {
        path: '/settings/pixel',
        name: 'Pixel',
        component: () => import('@/views/settings/pixel/index.vue'),
        meta: {
          title: 'pixel',
          icon: 'icon-meta-line'
        }
      },
      {
        path: '/settings/coupon',
        name: 'Coupon',
        component: () => import('@/views/settings/coupon/index.vue'),
        meta: {
          title: 'coupon',
          icon: 'icon-coupon'
        }
      },
      {
        path: '/settings/violationRecord',
        name: 'violationRecord',
        component: () => import('@/views/settings/violationRecord/index.vue'),
        meta: {
          title: 'violationRecord',
          icon: 'icon-weiguidengji'
        }
      },
      {
        path: '/settings/couponAdd',
        name: 'CouponAdd',
        component: () => import('@/views/settings/coupon/CouponConfig.vue'),
        meta: {
          title: 'coupon',
          hidden: true
        }
      },
      {
        path: '/settings/feeTerms',
        name: 'feeTerms',
        component: () => import('@/views/settings/feeTerms/index.vue'),
        meta: {
          title: 'feeTerms',
          icon: 'icon-a-querenhetongquerenhetongqueding'
        }
      },
      {
        path: '/settings/tutorial',
        name: 'tutorial',
        component: () => import('@/views/settings/tutorial/index.vue'),
        meta: {
          title: 'tutorial',
          icon: 'icon-video'
        }
      },
      {
        path: '/settings/order-style-config',
        name: 'OrderStyleConfigPage',
        component: () => import('@/views/settings/orderPageStyle/index.vue'),
        meta: {
          title: 'orderPageDesigner',
          icon: 'icon-checkout'
        }
      }
      /*     {
        path: '/settings/Pixel',
        name: 'Pixel',
        component: () => import('@/views/settings/pixel/Pixel.vue')
      } */
    ]
  },
  /* 帮助中心 */
  {
    path: '/helpcenter',
    name: 'Helpcenter',
    component: Layout,
    redirect: '/helpcenter/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/helpcenter/index.vue')
      }
    ]
  },
  /* 404页面 */
  {
    path: '/:pathMatch(.*)*',
    meta: {
      hidden: true
    },
    name: 'not-found',
    component: () => import('@/views/error/404.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
